import { Serializable } from '@admin/core/models/serializable';
import { ProviderWebsiteModel } from '@admin/shared/models/provider-website-model';
import { ProductType } from '@admin/product-purchases/shared/models/product-type';

export class MonthlyPlanItem implements Serializable<MonthlyPlanItem> {
  public monthlyPlanItemId: number;
  public monthlyPlanId: number;
  public productCode: string;
  public website: ProviderWebsiteModel;
  public productTypeId: ProductType;
  public count: number;

  fromObject(object: any): MonthlyPlanItem {
    Object.assign(this, object);
    return this;
  }

  toObject() {
    return {
      MonthlyPlanItemId: this.monthlyPlanItemId,
      MonthlyPlanId: this.monthlyPlanId,
      ProductCode: this.productCode,
      Website: this.website.toObject(),
      ProductTypeId: this.productTypeId,
      Count: this.count,
    };
  }
}
